import { z } from 'zod';
export const ZBrowser = z.enum([
    'Chrome',
    'Safari',
    'Firefox',
    'Opera',
    'Edge',
    'Internet Explorer',
    'Unknown',
]);
export const ZOs = z.enum(['Windows', 'Linux', 'MacOS', 'iOS', 'Android', 'Unknown']);
export const ZDeviceType = z.enum(['Mobile', 'Desktop', 'Tablet']);
//# sourceMappingURL=utils.js.map